module.exports = __webpack_public_path__ + "static/media/ikaruga.acba832d.jpg";